import CreateHomeworkIdeaView from "@features/tools/view/homework-ideas-view/create-homework-idea-view";

const CreateHomeworkIdea = () => {
  return <CreateHomeworkIdeaView />;
};

export default CreateHomeworkIdea;
